import $ from 'jquery';

const timeline = () => {
  $('.timeline__scroller-right').click(() => {
    $('.timeline__container').animate({ scrollLeft: '+=200' }, 500);
  });

  $('.timeline__scroller-left').click(() => {
    $('.timeline__container').animate({ scrollLeft: '-=200' }, 500);
  });
};

export default () => {
  timeline();
};
